import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft, Phone, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";

export const SuccessPanel = ({ onReset, requestId }) => {
  return (
    <div
      className="rounded-xl border bg-white p-8 sm:p-12 text-center"
      style={{ borderColor: "#E2E8F0" }}
      data-testid="success-panel"
    >
      <div
        className="mx-auto grid h-16 w-16 place-items-center rounded-full"
        style={{ background: "rgba(212, 175, 55, 0.12)" }}
      >
        <CheckCircle2 className="h-8 w-8" style={{ color: "#D4AF37" }} strokeWidth={2.2} />
      </div>
      <div className="tj-gold-rule mx-auto mt-6" />
      <h2
        className="font-display mt-5 text-3xl sm:text-4xl font-bold tracking-tight"
        style={{ color: "#0B2545" }}
        data-testid="success-heading"
      >
        Message Received. Care Is In Motion.
      </h2>
      {requestId && (
        <div className="mt-5 inline-flex items-center gap-2 rounded-full border px-4 py-2"
             style={{ borderColor: "rgba(212,175,55,0.45)", background: "rgba(212,175,55,0.10)" }}
             data-testid="success-request-id">
          <span className="text-[10px] uppercase tracking-[0.22em] font-medium" style={{ color: "#7A5E12" }}>
            Your Request ID
          </span>
          <span className="font-display text-base font-bold tracking-wide" style={{ color: "#0B2545" }}>
            {requestId}
          </span>
        </div>
      )}
      <p
        className="mt-4 max-w-xl mx-auto text-base leading-relaxed"
        style={{ color: "#475569" }}
      >
        Thank you for contacting T&amp;J Clinical Solutions. Our team will review
        your request and contact you shortly. Keep your Request ID handy for follow-up.
      </p>

      <div className="mt-8 grid gap-3 sm:grid-cols-2 max-w-md mx-auto text-left">
        <div
          className="flex items-center gap-3 rounded-md border bg-white px-4 py-3"
          style={{ borderColor: "#E2E8F0" }}
        >
          <Phone className="h-4 w-4" style={{ color: "#0B2545" }} />
          <div>
            <div className="text-[10px] uppercase tracking-[0.2em] font-medium" style={{ color: "#475569" }}>
              Urgent
            </div>
            <div className="text-sm font-semibold" style={{ color: "#0B2545" }}>
              Call our dispatch line
            </div>
          </div>
        </div>
        <div
          className="flex items-center gap-3 rounded-md border bg-white px-4 py-3"
          style={{ borderColor: "#E2E8F0" }}
        >
          <Mail className="h-4 w-4" style={{ color: "#0B2545" }} />
          <div>
            <div className="text-[10px] uppercase tracking-[0.2em] font-medium" style={{ color: "#475569" }}>
              Email
            </div>
            <div className="text-sm font-semibold" style={{ color: "#0B2545" }}>
              tj.clinicalsolutions@gmail.com
            </div>
          </div>
        </div>
      </div>

      <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
        <Button
          onClick={onReset}
          variant="outline"
          className="h-11 px-5 border-[1.5px]"
          style={{ borderColor: "#0B2545", color: "#0B2545" }}
          data-testid="submit-another-button"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Submit another request
        </Button>
        <Link to="/">
          <Button
            className="h-11 px-5 text-white"
            style={{ background: "#0B2545" }}
            data-testid="back-home-button"
          >
            Back to home
          </Button>
        </Link>
      </div>

      <div className="mt-10 flex justify-center">
        <Logo size="md" />
      </div>
    </div>
  );
};

export default SuccessPanel;
